import React, { useEffect, useState } from 'react'
import Collapse from '@material-ui/core/Collapse'
import ConditionalWrap from 'conditional-wrap'

const NewsFilters = (props) => {
  const { categories, currentFilters, filterChange } = props
  const [dropdowns, setDropdowns] = useState({
    categories: false,
  })
  const [windowWidth, setWindowWidth] = useState(0)
  const [openFilters, setOpenFilters] = useState(false)
  const [filters, setFilters] = useState(currentFilters)
  const [selectedCategories, setSelectedCategories] = useState({})

  useEffect(() => {
    window.addEventListener('resize', saveWindowWidth)
    document.addEventListener('load', saveWindowWidth())

    return () => {
      window.removeEventListener('resize', saveWindowWidth)
      document.removeEventListener('load', saveWindowWidth)
    }
  }, [])

  useEffect(() => {
    setFilters(currentFilters)
  }, [currentFilters])

  useEffect(() => {
    if (categories.length) {
      const initialCategories = {}
      categories.forEach((category) => {
        if (!filters.categories.includes(category)) {
          initialCategories[category] = false
        } else {
          initialCategories[category] = true
        }
      })

      setSelectedCategories(initialCategories)
    }
  }, [categories])

  const saveWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }

  const clearCategories = () => {
    const updatedCategories = { ...selectedCategories }

    const keys = Object.keys(updatedCategories)
    for (const key of keys) {
      updatedCategories[key] = false
    }

    setSelectedCategories(updatedCategories)
    filterChange({
      ...filters,
      categories: [],
      page: 1
    })
  }

  const saveCategories = () => {
    const selectedIds = []

    categories.forEach((category) => {
      if (selectedCategories[category]) {
        selectedIds.push(category)
      }
    })

    filterChange({
      ...filters,
      categories: selectedIds,
      page: 1
    })
  }

  const filterObjects = [
    <div key='categories'>
      {Object.keys(selectedCategories).length > 0 && (
        <div key='categories'>
          <div className='filters__dropdown'>
            <button
              type='button'
              className={dropdowns.category ? 'open' : ''}
              onClick={() =>
                setDropdowns({
                  ...dropdowns,
                  categories: !dropdowns.categories,
                })
              }
            >
              Types
            </button>

            <div className='filters__options'>
              <Collapse in={dropdowns.categories}>
                <div className='filters__options__inner'>
                  <ul>
                    {categories.map((category) => (
                      <li key={category}>
                        <label className='filters__option'>
                          <input
                            value={selectedCategories[category] || false}
                            checked={selectedCategories[category]}
                            type='checkbox'
                            onChange={() => {
                              setSelectedCategories({
                                ...selectedCategories,
                                [category]: !selectedCategories[
                                  category
                                ],
                              })
                            }}
                          />
                          <span />
                          <span>{category}</span>
                        </label>
                      </li>
                    ))}
                  </ul>

                  <div className='filters__controls'>
                    <button
                      type='button'
                      className='filters__control filters__control--clear'
                      onClick={clearCategories}
                    >
                      Clear
                    </button>

                    <button
                      type='button'
                      className='filters__control filters__control--save'
                      onClick={saveCategories}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </div>
      )}
    </div>,
  ]

  return (
    <div>
      {categories.length > 0 ? (
        <div className='filters'>
          <button
            className={`filters__open ${
              openFilters ? 'filters__open--close' : ''
            }`}
            onClick={() => setOpenFilters(!openFilters)}
          >
            Filter Results
          </button>

          <ConditionalWrap
            condition={windowWidth < 1340}
            wrap={(children) => (
              <Collapse in={openFilters}>{children}</Collapse>
            )}
          >
            {filterObjects}
          </ConditionalWrap>
        </div>
      ) : null}
    </div>
  )
}

export default NewsFilters
